/**
 * ============================================================================
 * ギフトラッピング + RFID 両方選択時の合成画像表示（WEBOCH追加 2026-07-05）
 * ============================================================================
 *
 * 【概要】
 * - 商品メタフィールド custom.gift_rfid_combo_image に合成画像が設定されて
 *   いる商品でのみ動作する（未設定の商品では data-combo-image 属性自体が
 *   出力されないため、このスクリプトは何もしない）。
 * - variant:change イベント（theme.js の VariantPicker が発火・bubbles:true）
 *   を document 側で独立して購読するだけで、theme.js 本体は一切変更しない。
 * - 「ギフトラッピング＝あり」かつ「RFID＝あり」のバリアントが選択された
 *   ときだけ、そのバリアントの featured_media に対応するメイン画像スライドの
 *   <img> の src を合成画像へ一時的に差し替える。
 * - それ以外のバリアントに切り替わったら、元の画像に必ず復元する。
 * - サムネイル一覧（ライブラリ）は product.media のみを描画しているため、
 *   合成画像がサムネイルに現れることはない。
 *
 * 【ロールバック方法】
 * - product-gallery.liquid 末尾の script 読み込み1行を削除するだけで、
 *   全ての挙動が元に戻る（このファイル自体は残っていても無害）。
 * ============================================================================
 */
(function () {
  'use strict';

  var SWAPPED_ATTR = 'data-combo-swapped';
  var ORIG_SRC_ATTR = 'data-combo-original-src';
  var ORIG_SRCSET_ATTR = 'data-combo-original-srcset';

  /**
   * オプション値が「選択されている」かどうかを判定する。
   * line-item.liquid（カート内表示・本番稼働中）と同じ考え方:
   * 値が空でなく、「なし」で始まらないものを「あり」とみなす。
   * 例: "あり(+300円)" → true / "なし" → false / "" → false
   */
  function isSelected(value) {
    if (typeof value !== 'string') {
      return false;
    }
    var v = value.trim();
    return v !== '' && v.indexOf('なし') !== 0;
  }

  /**
   * このスクリプトが過去に差し替えた画像を、すべて元の状態へ復元する。
   * （差し替え時に保存しておいた元の src / srcset を書き戻す）
   */
  function restoreSwappedImages(gallery) {
    var imgs = gallery.querySelectorAll('img[' + SWAPPED_ATTR + ']');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];

      var originalSrc = img.getAttribute(ORIG_SRC_ATTR);
      if (originalSrc !== null && originalSrc !== '') {
        img.setAttribute('src', originalSrc);
      }

      var originalSrcset = img.getAttribute(ORIG_SRCSET_ATTR);
      if (originalSrcset !== null && originalSrcset !== '') {
        img.setAttribute('srcset', originalSrcset);
      } else {
        img.removeAttribute('srcset');
      }

      img.removeAttribute(SWAPPED_ATTR);
      img.removeAttribute(ORIG_SRC_ATTR);
      img.removeAttribute(ORIG_SRCSET_ATTR);
    }
  }

  /**
   * バリアント情報を受け取り、条件（ギフトあり かつ RFIDあり）を満たす場合
   * のみ合成画像へ差し替える。満たさない場合は復元のみ行う。
   */
  function applyComboImage(gallery, variant) {
    var comboUrl = gallery.getAttribute('data-combo-image');
    var giftIndex = gallery.getAttribute('data-combo-gift-option');
    var rfidIndex = gallery.getAttribute('data-combo-rfid-option');

    if (!comboUrl || !giftIndex || !rfidIndex) {
      return;
    }

    // まず必ず元の状態に戻す（バリアント切り替えのたびにリセット）
    restoreSwappedImages(gallery);

    if (!variant) {
      return;
    }

    var giftValue = variant['option' + giftIndex];
    var rfidValue = variant['option' + rfidIndex];

    // 「両方あり」でなければ、ここで終了（＝通常の画像表示のまま）
    if (!isSelected(giftValue) || !isSelected(rfidValue)) {
      return;
    }

    var media = variant.featured_media;
    if (!media || !media.id) {
      return;
    }

    var slide = gallery.querySelector(
      '.product-gallery__media[data-media-id="' + media.id + '"]'
    );
    if (!slide) {
      return;
    }

    var img = slide.querySelector('img');
    if (!img || img.hasAttribute(SWAPPED_ATTR)) {
      return;
    }

    // 元の値を保存してから差し替え（srcsetは高解像度の元画像が優先表示
    // されてしまうため必ず外し、合成画像のsrc一本にする）
    img.setAttribute(ORIG_SRC_ATTR, img.getAttribute('src') || '');
    img.setAttribute(ORIG_SRCSET_ATTR, img.getAttribute('srcset') || '');
    img.setAttribute(SWAPPED_ATTR, 'true');
    img.removeAttribute('srcset');
    img.setAttribute('src', comboUrl);
  }

  /**
   * バリアント切り替え時（theme.jsのVariantPickerがform要素に発火し、
   * bubbles:trueでdocumentまで伝播してくるイベントを購読）
   *
   * 【注意】event.detail.formId は使わない。
   * Shopifyの商品フォームには <input name="id"> が含まれるため、DOMの仕様で
   * form.id が「id文字列」ではなく「そのinput要素」を返してしまう
   * （theme.js自身も form.id.value と書いていることから確認済み）。
   * そのため、イベント発生源のform要素から getAttribute('id') で
   * 属性値の文字列を直接取得する。
   */
  document.addEventListener('variant:change', function (event) {
    var target = event.target;
    var formId =
      target && typeof target.getAttribute === 'function'
        ? target.getAttribute('id')
        : null;

    // 念のためのフォールバック（formIdが文字列で渡ってきた場合のみ使用）
    if (!formId && event.detail && typeof event.detail.formId === 'string') {
      formId = event.detail.formId;
    }

    if (!formId) {
      return;
    }

    var gallery = document.querySelector(
      'product-gallery[form="' + formId + '"][data-combo-image]'
    );
    if (!gallery) {
      return;
    }

    applyComboImage(gallery, (event.detail && event.detail.variant) || null);
  });

  /**
   * 初期表示時の処理:
   * ?variant=xxx 付きURLで「両方あり」バリアントが最初から選択されている
   * 場合、variant:change は発火しないため、variant-picker 内に埋め込まれて
   * いる初期バリアントJSON（script[data-variant]）を読んで同じ判定を行う。
   */
  function initOnLoad() {
    var galleries = document.querySelectorAll('product-gallery[data-combo-image]');
    for (var i = 0; i < galleries.length; i++) {
      var gallery = galleries[i];
      var formId = gallery.getAttribute('form');
      if (!formId) {
        continue;
      }

      var picker = document.querySelector(
        'variant-picker[form-id="' + formId + '"]'
      );
      var scriptEl = picker
        ? picker.querySelector('script[data-variant]')
        : null;
      if (!scriptEl) {
        continue;
      }

      try {
        var variant = JSON.parse(scriptEl.textContent || 'null');
        applyComboImage(gallery, variant);
      } catch (e) {
        // JSONが読めない場合は何もしない（既存表示に影響を与えない）
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOnLoad);
  } else {
    initOnLoad();
  }
})();